import { Card, Button, Alert } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { FaShieldAlt, FaSignOutAlt } from 'react-icons/fa';

export default function Unauthorized() {
  const navigate = useNavigate();
  const { logout, user } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login', { replace: true });
  };

  return (
    <div className="d-flex align-items-center justify-content-center vh-100 bg-light">
      <Card style={{ maxWidth: '500px' }} className="shadow-sm">
        <Card.Body className="text-center p-5">
          <FaShieldAlt size={64} className="text-danger mb-4" />
          <Card.Title as="h2" className="mb-3">
            Access Denied
          </Card.Title>
          <Alert variant="danger" className="mb-4">
            <Alert.Heading>Not Authorized as Admin</Alert.Heading>
            <p className="mb-0">
              Your email <strong>{user?.email || 'unknown'}</strong> is not authorized to access the admin dashboard.
            </p>
            <p className="mb-0 mt-2">
              Only authorized admin emails can access this system.
            </p>
          </Alert>
          <div className="d-flex gap-2 justify-content-center">
            <Button variant="primary" onClick={() => navigate(-1)}>
              Go Back
            </Button>
            <Button variant="outline-danger" onClick={handleLogout}>
              <FaSignOutAlt className="me-2" />
              Logout
            </Button>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

